module.exports = __webpack_public_path__ + "static/features-section-bg-f13148e8c1e020faecb94456e7090dfd.jpg";